import { CloseIcon } from '@treneo/shared/icons';

import type { SxProps, Theme } from '@mui/material';

import { IconButton } from './icon-button';

type Props = {
  onClose: () => void;
  className?: string;
  sx?: SxProps<Theme>;
  size?: 'small' | 'medium' | 'large';
  fontSize?: 'inherit' | 'large' | 'medium' | 'small';
  'aria-label'?: string;
};

export const CloseIconButton = ({
  onClose,
  className,
  sx,
  size = 'medium',
  fontSize = 'medium',
  'aria-label': ariaLabel = 'close'
}: Readonly<Props>) =>
  onClose ? (
    <IconButton aria-label={ariaLabel} onClick={onClose} className={className} sx={sx} size={size}>
      <CloseIcon fontSize={fontSize} />
    </IconButton>
  ) : null;
